/** 조건부 클래스 결합. 라이브러리(clsx)를 넣을 만한 분량이 아니라 4줄로 둡니다. */
export const cx = (...parts: (string | false | null | undefined)[]): string =>
  parts.filter(Boolean).join(" ");
